import React from 'react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-white pt-8 pb-12 px-4 sm:px-6" data-id="element-146">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-147">
        <h1 className="font-archivo text-4xl sm:text-5xl md:text-6xl leading-[1.1] text-brand-black uppercase" data-id="element-148">
          🌱 Ayudá a tu hijo a crecer jugando con{' '}
          <span className="highlight-yellow" data-id="element-149">
            100 actividades simples y estimulantes
          </span>
        </h1>

        <a href="https://impulsodigital.vip/cart/44763616936022:1" className="block mx-auto max-w-lg cursor-pointer hover:opacity-95 transition-opacity" data-id="element-150">
          <img src="https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=1080&h=1080&fit=crop" alt="Crecer Jugando Kit" className="w-full rounded-2xl shadow-2xl border-4 border-gray-100" data-id="element-151" />
        </a>

        <div className="space-y-4" data-id="element-152">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-800" data-id="element-153">
            Sin pantallas. Sin estrés. Sin pasar horas pensando qué hacer.
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 font-medium max-w-2xl mx-auto" data-id="element-154">
            Un kit imprimible diseñado para estimular el lenguaje, la
            creatividad, el movimiento y las emociones desde casa.
          </p>
          <p className="text-xl font-bold text-brand-red bg-red-50 inline-block px-4 py-2 rounded-full" data-id="element-155">
            ✨ Incluye 5 BONUS exclusivos de regalo.
          </p>
        </div>

        <div className="bg-gray-50 rounded-xl p-6 sm:p-8 text-left max-w-xl mx-auto border border-gray-200 shadow-sm" data-id="element-156">
          <ul className="space-y-3 font-medium text-gray-700 sm:text-lg" data-id="element-157">
            <li className="flex items-start gap-3" data-id="element-158">
              <span className="text-brand-green text-xl" data-id="element-159">✔</span> +100
              actividades listas para usar
            </li>
            <li className="flex items-start gap-3" data-id="element-160">
              <span className="text-brand-green text-xl" data-id="element-161">✔</span> Ideal para
              niños de 0 a 5 años
            </li>
            <li className="flex items-start gap-3" data-id="element-162">
              <span className="text-brand-green text-xl" data-id="element-163">✔</span> Actividades
              simples y rápidas
            </li>
            <li className="flex items-start gap-3" data-id="element-164">
              <span className="text-brand-green text-xl" data-id="element-165">✔</span> Sin necesidad
              de materiales costosos
            </li>
            <li className="flex items-start gap-3" data-id="element-166">
              <span className="text-brand-green text-xl" data-id="element-167">✔</span> Ayuda a
              reducir el tiempo frente a pantallas
            </li>
            <li className="flex items-start gap-3" data-id="element-168">
              <span className="text-brand-green text-xl" data-id="element-169">✔</span> Formato PDF
              imprimible con acceso inmediato
            </li>
          </ul>
        </div>

        <div className="space-y-2 py-4" data-id="element-170">
          <div className="text-2xl text-gray-400 line-through font-bold" data-id="element-171">
            $49.990
          </div>
          <div className="text-4xl sm:text-5xl font-archivo text-brand-red" data-id="element-172">
            👉 HOY SOLO $16.990 ARS
          </div>
        </div>

        <div className="space-y-4" data-id="element-173">
          <CTAButton text="🌱 QUIERO EL KIT COMPLETO" color="green" data-id="element-174" />
          <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-6 text-sm sm:text-base font-semibold text-gray-600" data-id="element-175">
            <span data-id="element-176">📩 Descarga inmediata</span>
            <span className="hidden sm:inline" data-id="element-177">•</span>
            <span data-id="element-178">💻 Compatible con celular, tablet y PC</span>
            <span className="hidden sm:inline" data-id="element-179">•</span>
            <span data-id="element-180">🖨️ Formato imprimible</span>
          </div>
        </div>
      </div>
    </section>;
}